import React, { Component } from 'react';
import { Modal,
    Alert,
    FormGroup,
    ControlLabel,
    FormControl,
    Button,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';

// To handle requests
import AccountsAPI from '../utils/AccountsAPI';
import {
    passwordValidator,
    passwordConfirmationValidator,
    validatePasswordFields,
    getPasswordValidationState,
    PASSWORD_MIN_LENGTH,
    PASSWORD_MAX_LENGTH
} from '../utils/passwordValidation';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

const alertStyle = { marginTop: '5px', marginBottom: '0px' };
const SUCCESS_MODAL_TIMEOUT = 2000;

class ChangeOwnPasswordComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalErrorAlert: '',
            currentPassword: '',
            newPassword: '',
            confirmationPassword: '',
            isSubmitting: false,
            success: false,
        };

        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitPassword = this.submitPassword.bind(this);
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            modalErrorAlert: '',
            currentPassword: '',
            newPassword: '',
            confirmationPassword: '',
            isSubmitting: false,
            success: false,
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    // Handle text input change to update state
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    // Fired when form is submitted
    submitPassword(e) {
        e.preventDefault();

        // Validate password fields
        const validation = validatePasswordFields(
            this.state.newPassword,
            this.state.confirmationPassword,
            this.state.currentPassword,
            true // require current password
        );

        if (!validation.isValid) {
            this.setState({
                modalErrorAlert: validation.errors[0],
            });
            return;
        }

        this.setState({ modalErrorAlert: '', isSubmitting: true });

        AccountsAPI.changeSelfPassword(
          this.state.currentPassword,
          this.state.newPassword
        ).then(() => {
              this.setState({
                  success: true,
                  currentPassword: '',
                  newPassword: '',
                  confirmationPassword: '',
                  isSubmitting: false,
              });
              // Small timeout so the user can see the success message, then redirect to login
              setTimeout(() => {
                  this.closeModal();
                  window.location.href = `${namespace}/login`;
              }, SUCCESS_MODAL_TIMEOUT);
          }).catch(message => {
              this.setState({ isSubmitting: false });
              if (message.status === 401) {
                  this.setState({
                      modalErrorAlert: 'Current password is incorrect.',
                  });
              } else if (message.status === 403) {
                  window.location.href = `${namespace}/login/error/${message.status}`;
              } else if (message.status === 400) {
                  this.setState({
                      modalErrorAlert: 'Invalid password format. Please ensure your password meets the requirements.',
                  });
              } else {
                  this.setState({
                      modalErrorAlert: 'Unable to process the request. Please try again.',
                  });
              }
          }
        );
    }


    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const successAlert = <Alert bsStyle="success">
          <strong>Success!</strong>
          <br />
          Your password has been changed successfully.
          <br />
          You will be redirected to the login page in a few seconds.
        </Alert>;

        const form = (
          <div>
            <form>

                <div className="form-group">
                  <FormGroup
                    controlId="formCurrentPassword"
                    validationState={null}>
                    <ControlLabel>
                      <i
                        className="fa fa-lock"
                        style={brandingStyles.mainColor}
                      />
                    &nbsp;Current password
                    </ControlLabel>
                    <FormControl
                        type="password"
                        value={this.state.currentPassword}
                        onChange={this.handleChange}
                        placeholder="Enter current password"
                        name="currentPassword"
                        disabled={this.state.isSubmitting}
                        style={brandingStyles.backgrounds.input}/>
                  </FormGroup>
                </div>

                <div className="form-group">
                  <FormGroup
                    controlId="formNewPassword"
                    validationState={
                      getPasswordValidationState(
                        this.state.newPassword,
                        passwordValidator
                      )
                    }>
                    <ControlLabel>
                      <i
                        className="fa fa-lock"
                        style={brandingStyles.mainColor}
                      />
                    &nbsp;New password
                    </ControlLabel>
                    <FormControl
                        type="password"
                        value={this.state.newPassword}
                        onChange={this.handleChange}
                        placeholder={`Enter new password (${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters)`}
                        name="newPassword"
                        disabled={this.state.isSubmitting}
                        style={brandingStyles.backgrounds.input}/>
                    <FormControl.Feedback />
                    {this.state.newPassword.length > 0 && !passwordValidator(this.state.newPassword) && (
                      <Alert bsStyle="danger" style={alertStyle}>
                        Password must be between {PASSWORD_MIN_LENGTH} and {PASSWORD_MAX_LENGTH} characters.
                      </Alert>
                    )}
                  </FormGroup>
                </div>

                <div className="form-group">
                  <FormGroup
                    controlId="formConfirmPassword"
                    validationState={
                      getPasswordValidationState(
                        this.state.confirmationPassword,
                        (password) => passwordConfirmationValidator(this.state.newPassword, password)
                      )
                    }>
                    <ControlLabel>
                      <i
                        className="fa fa-lock"
                        style={brandingStyles.mainColor}
                      />
                      &nbsp;Confirm new password
                    </ControlLabel>
                    <FormControl
                        type="password"
                        value={this.state.confirmationPassword}
                        onChange={this.handleChange}
                        placeholder="Confirm new password"
                        name="confirmationPassword"
                        disabled={this.state.isSubmitting}
                        style={brandingStyles.backgrounds.input}/>
                    <FormControl.Feedback />
                    {this.state.confirmationPassword.length > 0 &&
                     !passwordConfirmationValidator(this.state.newPassword, this.state.confirmationPassword) && (
                      <Alert bsStyle="danger" style={alertStyle}>
                        Passwords must match.
                      </Alert>
                    )}
                  </FormGroup>
                </div>

                {errorAlert}
                <Button
                  type="button"
                  onClick={this.submitPassword}
                  style={brandingStyles.buttons.primary}
                  className="btn btn-primary pull-right"
                  disabled={this.state.isSubmitting}
                >
                  {this.state.isSubmitting ? 'Changing...' : 'Change Password'}
                </Button>

            </form>
            <div className="clear-both"></div>
          </div>
        );

        return (
              <div>
                  <Modal show={this.props.showModal} onHide={this.state.isSubmitting ? null : this.closeModal}>
                      <Modal.Header
                        style={brandingStyles.backgrounds.panelHeader}
                      >
                          <Modal.Title
                            style={brandingStyles.backgrounds.panelHeader}
                          >
                              <i
                                className="fa fa-lock"
                                style={brandingStyles.mainColor}
                              ></i>
                              <span>&nbsp;</span>
                              {'Change Password'}
                              <i
                                  className="fa fa-times pull-right clickable"
                                  style={Object.assign(
                                    { marginTop: '3px' },
                                    brandingStyles.mainColor,
                                    this.state.isSubmitting ? { opacity: 0.5, pointerEvents: 'none' } : {}
                                  )}
                                  onClick={this.state.isSubmitting ? null : this.closeModal}
                              ></i>
                          </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={brandingStyles.backgrounds.panel}>
                        {this.state.success ? successAlert : form}
                      </Modal.Body>
                  </Modal>
              </div>
        );
    }

}

ChangeOwnPasswordComponent.propTypes = {
    showModal: PropTypes.bool,
    onClose: PropTypes.func,
};

export default ChangeOwnPasswordComponent;



/** WEBPACK FOOTER **
 ** ./src/components/ChangeOwnPasswordButton.js
 **/